let myComponent = {};

/**
 * 视频预览图
 * @param Vue
 * @param options
 */
myComponent.install = function (Vue, options) {

    /**
     * 视频预览图，点击回调传入视频url
     */
    Vue.component("video-preview", {
        props: [
            "url",
            "width",
            "height"
        ],
        created() {
        },
        render: function (h) {
            let _this = this;
            return h('div', {
                'class': "video_preview",
                style: {
                    width: _this.width ? (_this.width + "px") : "",
                    height: _this.height ? (_this.height + "px") : "",
                },
                on: {
                    click: () => {
                        _this.$emit("play", _this.url);
                    }
                }
            }, [
                h("img", {
                    attrs: {
                        src: _this.url.indexOf("leadersir") == -1 ? "http://assets.program.leadersir.cn/imgs/video_cover.jpg":(_this.url + "?vframe/jpg/offset/1")
                    }
                }),
                h("div", {
                    'class': "video_preview-shadow fx fx-center"
                }, [
                    h("i", {
                        'class': "el-icon-video-play"
                    })
                ])
            ])
        }

    })

    /**
     * 文件连接，点击可预览或下载
     */
    Vue.component("file-link", {
        props: [
            "url",
            "title"
        ],
        computed: {
            "fileType": function () {
                let suffix = this.title.substring(this.title.lastIndexOf(".") + 1).toLowerCase();
                if (suffix.indexOf("/") > -1) return "other"; //不带后缀名的情况
                switch (suffix) {
                    case "pdf":
                        return "pdf";
                    case "doc":
                    case "docx":
                        return "word";
                    case "ppt":
                    case "pptx":
                    case "ppsx":
                        return "ppt";
                    case "xls":
                    case "xlsx":
                        return "excel";
                    case "zip":
                    case "rar":
                        return "zip";
                    case "jpg":
                    case "png":
                    case "bmp":
                    case "jpeg":
                    case "svg":
                        return "pic";
                    case "mp4":
                    case "3gp":
                    case "avi":
                    case "flv":
                        return "video";
                    case "mp3":
                        return "audio";
                    case "m3u8":
                        return "video";
                    default:
                        return "other";
                }
            }
        },
        methods: {
            download() {

                const a = document.createElement('a'); // 创建a标签
                a.setAttribute('download', this.title);// download属性
                a.setAttribute('href', this.url);// href链接
                a.click();
            },
            getFileIcon() {
                switch (this.fileType) {
                    case "ppt":
                        return "iconfont icon-ppt";
                    case "word":
                        return "iconfont icon-word";
                    case "excel":
                        return "iconfont icon-excel";
                    case "pdf":
                        return "iconfont icon-pdf";
                    case "zip":
                        return "iconfont icon-yasuo";

                    default:
                        return "iconfont icon-commonfile";

                }
            },
            canPreview() {
                return this.fileType == "video" || this.fileType == "pdf" || this.fileType == "word" || this.fileType == "ppt" || this.fileType == "excel";
            },
            preview() {
                if (this.fileType == "pdf") {
                    window.open(this.url, "_blank", "width=800,height=800,location=no,channelmode=yes")
                } else if (this.fileType == "video") {
                    this.$emit("play", this.url);
                } else {
                    window.open("https://view.officeapps.live.com/op/view.aspx?src=" + this.url, "_blank", "width=800,height=800,location=no,channelmode=yes")
                }
            },
        },
        render: function (h) {
            let _this = this;
            let iconClass = this.getFileIcon();
            return h("el-link", {
                attrs: {
                    type: "primary",
                    underline: false,
                },
                on: {
                    "click": () => {
                        if (_this.canPreview()) {
                            _this.preview();
                        } else {
                            _this.download();
                        }
                    }
                }
            }, [
                h("i", {
                    "class": iconClass
                }),
                this.title
            ])

        }


    })

    /**
     * 文件预览图
     */
    Vue.component("file-preview", {
        props: [
            "url",
            "allowDownload",
            "allowPreview",
            "width",
            "height",
            "hideName"
        ],
        computed: {
            fileName() {
                let url = unescape(this.url);
                return url.substring(url.lastIndexOf("/") + 1)
            },
            fileType() {
                let suffix = this.url.substring(this.url.lastIndexOf(".") + 1).toLowerCase();
                if (suffix.indexOf("/") > -1) return "other"; //不带后缀名的情况
                switch (suffix) {
                    case "pdf":
                        return "pdf";
                    case "doc":
                    case "docx":
                        return "word";
                    case "ppt":
                    case "pptx":
                    case "ppsx":
                        return "ppt";
                    case "xls":
                    case "xlsx":
                        return "excel";
                    case "zip":
                    case "rar":
                        return "zip";
                    case "jpg":
                    case "png":
                    case "bmp":
                    case "jpeg":
                    case "svg":
                        return "pic";
                    case "mp4":
                    case "3gp":
                    case "avi":
                    case "flv":
                        return "video";
                    case "mp3":
                        return "audio";
                    case "m3u8":
                        return "video";
                    default:
                        return "other";
                }
            },
            fileIcon() {
                switch (this.fileType) {
                    case "ppt":
                        return "iconfont icon-ppt";
                    case "word":
                        return "iconfont icon-word";
                    case "excel":
                        return "iconfont icon-excel";
                    case "pdf":
                        return "iconfont icon-pdf";
                    case "zip":
                        return "iconfont icon-yasuo";

                    default:
                        return "iconfont icon-file";

                }
            }

        },
        methods: {
            download() {

                const a = document.createElement('a'); // 创建a标签
                a.setAttribute('download', this.fileName);// download属性
                a.setAttribute('href', this.url);// href链接
                a.setAttribute('target', "_blank");// href链接
                a.click();
            },
            canPreview(type) {
                return type == "pdf" || type == "word" || type == "ppt" || type == "excel";
            },
            preview(type) {
                if (type == "pdf") {
                    window.open(this.url, "_blank", "width=800,height=800,location=no,channelmode=yes")
                } else {
                    window.open("https://view.officeapps.live.com/op/view.aspx?src=" + this.url, "_blank", "width=800,height=800,location=no,channelmode=yes")
                }
            },

            getFileIcon() {
                switch (this.fileType) {
                    case "ppt":
                        return "iconfont icon-ppt";
                    case "word":
                        return "iconfont icon-word";
                    case "excel":
                        return "iconfont icon-excel";
                    case "pdf":
                        return "iconfont icon-pdf";
                    case "zip":
                        return "iconfont icon-yasuo";

                    default:
                        return "iconfont icon-commonfile";

                }
            },
            play() {
                this.$emit("play", this.url);
            }

        },
        render: function (h) {
            let _this = this;
            let optIcons = [];
            let fileType = _this.fileType;

            // if (this.allowDownload) {
            //     optIcons.push(h("i", {
            //         'class': "el-icon-download",
            //         on: {
            //             "click": () => {
            //                 _this.download()
            //             }
            //         }
            //     }))
            // }
            //可预览的出预览，不可预览出下载
            if (this.allowPreview && _this.canPreview(fileType)) {
                optIcons.push(h("i", {
                    'class': "el-icon-view",
                    on: {
                        "click": () => {
                            _this.preview(fileType)
                        }
                    }
                }))
            }else {
                optIcons.push(h("i", {
                    'class': "el-icon-download",
                    on: {
                        "click": () => {
                            _this.download()
                        }
                    }
                }))
            }
            return fileType == "pic" ? //图片
                h("el-image", {
                    style: {
                        width: _this.width ? (_this.width + "px") : "120px",
                        height: _this.height ? (_this.height + "px") : "120px"
                    },
                    attrs: {
                        src: _this.url,
                        "previewSrcList": [_this.url],
                        fit: "cover"
                    }

                })

                :

                fileType == "video" ?

                    h("video-preview", {
                        attrs: {
                            url: _this.url,
                            width: _this.width,
                            height: _this.height
                        },
                        on: {
                            play: () => {
                                _this.play()
                            }
                        }

                    })

                    :

                    h('div', { //其他类型文件
                        'class': "file_preview",
                        style: {
                            width: _this.width ? (_this.width + "px") : "",
                            height: _this.height ? (_this.height + "px") : "",
                        },
                        on: {}
                    }, [
                        h("div", {
                            "class": "file_preview-icon fx fx-center"
                        }, [
                            h("i", {
                                "class": _this.fileIcon
                            })
                        ]),
                        _this.hideName?null:
                        h("div", {
                            "class": "file_preview-title ellipsis"
                        }, [_this.fileName]),

                        optIcons.length > 0 ? h("div", {
                            'class': "file_preview-shadow fx fx-center"
                        }, optIcons) : null
                    ])
        }

    })

    /**
     * 标签组
     */
    Vue.component("tag-group", {
        props: [
            "tags",
            "size",
            "color"
        ],
        render: function (h) {
            let size = this.size ? this.size : "small";
            let defaultColors = ["#409eff", "#f4911f", "#ff4754", "#00ca80"];
            let _this = this;
            return h("div", {
                    'class': "tag-group fx fx-m_center fx-c_center fx-wrap"
                },
                this.tags ? this.tags.map((item, i) => h("el-tag", {
                    attrs: {
                        size: size,
                        effect: "dark",
                        color: _this.color ? _this.color : defaultColors[i % defaultColors.length]
                    }
                }, [item])) : []
            )
        }
    })
    /**
     * 文字开关
     */
    Vue.component("text-switch", {
        props: {
            value: {
                type: Boolean,
                default: false
            },
            onText: {
                type: String,
                default: "开启"
            },
            offText: {
                type: String,
                default: "关闭",
            }
        },
        methods: {
            handleClick() {
                let value = !this.value;
                this.$emit("input", value);
                this.$emit("change");
            }
        },
        render: function (h) {
            let _this = this;
            return h("div", {
                    'class': `text-switch text-switch_${_this.value ? 'on' : 'off'}`,
                    on: {
                        "click": () => {_this.handleClick()}
                    }
                },[
                    h("span", {
                        'class': "text-switch-label"
                    },[
                        _this.value ? _this.onText : _this.offText
                    ])
                ]
            )
        }
    })

}

export default myComponent;
